// src/components/ConversationWindow.js

import React, { useEffect, useRef } from 'react';
import BotMessage from './BotMessage';
import UserMessage from './UserMessage';

function ConversationWindow({ history, subtitleMode }) {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [history]);

  return (
    <div className="message-list">
      {history.map((message, index) =>
        message.speaker === 'bot' ? (
          <BotMessage key={index} message={message} subtitleMode={subtitleMode} />
        ) : (
          <UserMessage key={index} message={message} subtitleMode={subtitleMode} />
        )
      )}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default ConversationWindow;